"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultZeroResult = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const SearchResultZeroResult = ({ isZeroResult, zeroResultMessage, }) => {
    if (!isZeroResult) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)("div", { className: "container-px", children: (0, jsx_runtime_1.jsx)("div", { className: "sm:mb-7xl mb-8  w-full flex justify-center", children: (0, jsx_runtime_1.jsxs)("div", { className: " text-left", children: [(0, jsx_runtime_1.jsx)("h1", { className: " text-primary my-3xl sm:my-5xl", children: zeroResultMessage === null || zeroResultMessage === void 0 ? void 0 : zeroResultMessage.title }), (0, jsx_runtime_1.jsx)("div", { className: "mb-4 sm:mb-6" }), (0, jsx_runtime_1.jsx)("div", { className: "prose prose-danfoss", children: (0, app_1.StringToHTML)(zeroResultMessage === null || zeroResultMessage === void 0 ? void 0 : zeroResultMessage.description) })] }) }) }));
};
exports.SearchResultZeroResult = SearchResultZeroResult;
